export const TYPOGRAPHY = {
  FONT_FAMILY_DEFAULT: "'pretendard', 'Noto Sans SC', 'Noto Sans KR', sans-serif",
}
